module.exports = __webpack_public_path__ + "img/21.77259ae3.jpg";